import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import { CreditInfoModalContent } from 'shared/components/CreditInfoModalContent';
import { useCreditInfoModal } from 'shared/hooks/useCreditInfoModal';
import { CreditInfoModalFooter } from 'shared/components/CreditInfoModalFooter';
import { useSelector } from 'react-redux';
import { selectModalWindowRedirectParams } from 'shared/selectors/landing/selectModalWindowOfferParams';

interface ICreditInfoModalContainerProps {}

export const CreditInfoModalContainer: React.FC<ICreditInfoModalContainerProps> = () => {
  const { isModalOpen, handleModalClose, modalContent, handleFillApplicationClick } = useCreditInfoModal();
  const modalWindowRedirectParams = useSelector(selectModalWindowRedirectParams);

  const handleClick = () => {
    handleFillApplicationClick();
  };

  return (
    <ModalWindow
      open={isModalOpen}
      content={<CreditInfoModalContent creditInfo={modalContent} />}
      footer={
        <CreditInfoModalFooter handleFillApplicationClick={handleClick} buttonText={modalWindowRedirectParams?.text} />
      }
      onClose={handleModalClose}
      fixed
      width={880}
      size="XS"
      title="Все условия кредита"
    />
  );
};
